import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  searchdata: any[];
  selectedValue: any;
  i18n : any;
  keyword = 'name';
  data = [];
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  hideKbSearch: boolean= false;
  @Input() searchText 



  constructor(private homeService: HomeService, private router: Router) {
      this.i18n = homeService.session.get('i18n');
   }
  
  ngOnInit() {
    this.homeService.getKbSearchConfiguration().subscribe(res => {
      if (res.return_body !== null) {
        this.searchBanner = res.return_body.searchBanner;
        this.searchTextboxNote = res.return_body.searchTextboxNote;
        this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
        this.searchButtonHover = res.return_body.searchButtonHoverNote;
        this.hideKbSearch = res.return_body.hideKbSearchinHomePage;
      }
    });
  }

  selectEvent(item) {
    this.selectedValue = item.name;
    this.search(this.selectedValue);
  }

  onChangeSearch(val: string) {
    this.selectedValue = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  onFocused(e) {
    this.data = [];
  }

  search(selectedValue){
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 }});
  }
  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.search(searchkeyWrd);
  }

  searchCleared(){
    this.selectedValue = '';
  }
}
